import React from 'react';

export default ({isScrolling}) => (
  <svg className={`mouse ${isScrolling ? 'mouse--isScrolling' : ''}`} height="46" viewBox="0 0 30 46" width="30" xmlns="http://www.w3.org/2000/svg">
    <g className="mouse-body" fill="#fff" transform="">
      <path
        d="m15 0c8.2842712 0 15 6.71572875 15 15v16c0 8.2842712-6.7157288 15-15 15-8.28427125 0-15-6.7157288-15-15v-16c0-8.28427125 6.71572875-15 15-15zm0 2c-7.07713458 0-12.83342833 5.65519183-12.99644956 12.6931438l-.00355044.3068562v16c0 7.1797017 5.82029825 13 13 13 7.0771346 0 12.8334283-5.6551918 12.9964496-12.6931438l.0035504-.3068562v-16c0-7.17970175-5.8202983-13-13-13z"
        opacity=".24"/>
      <rect className="mouse-rect" height="8" opacity=".72" rx="2" width="4" x="13" y="12"/>
    </g>
  </svg>
)
